//import CommitChart from 'CommitChart'

<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              style=" margin-top"
              @click="previousTruckView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Vehicle No:- {{VehicleNo}}</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter>
          <md-layout md-flex="40">
            <h3>Location :- {{description}}</h3>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="40">
            <h3>Latitude :- {{latlong.lat}}</h3>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="40">
            <h3>Longitude :- {{latlong.lng}}</h3>
          </md-layout>
        </md-layout>
        <md-layout gutter style="margin-top:5%">
          <md-layout md-flex="20"></md-layout>
          <GmapMap
            :center="latlong"
            :zoom="15"
            map-type-id="hybrid"
            style="width: 700px; height: 500px"
          >
            <GmapMarker
              ref="myMarker"
              :position="google && new google.maps.LatLng(latlong.lat, latlong.lng)"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
            />
          </GmapMap>
        </md-layout>
      </md-card-content>
    </md-card>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import { gmapApi } from "vue2-google-maps";

//import Chart from 'vue-bulma-chartjs'

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/map");

    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },

  mounted() {
    console.log(">>>>>>> DASH", this.$store.getters.appContentMargin);
    // this.$store.dispatch("setSidebarMargin", 300);
    // this.$events.emit("toggleSideBar", true);
    console.log(">>>>>>> DASH <<<<<<<", this.$store.getters.appContentMargin);
    this.$events.emit("toggleSideBar", true);
    this.getCurrentLocation();
  },
  beforeDestroy() {},
  destroyed() {},
  components: { DatePicker },
  computed: { google: gmapApi },
  methods: {
    previousTruckView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/vehicle/viewVehicleDetail"
      //   // params:{
      //   //   "userId":res.data.Id,
      //   // }
      // });
    },

    getCurrentLocation() {
      let type_Size = {
        vehicleId: this.$sessionsStorage.get("editVehicleId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTruckLocation.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            this.latlong.lat = data.latLong.latitude;
            this.latlong.lng = data.latLong.longitude;
            this.VehicleNo = data.latLong.vehicleNo;
            this.description = data.latLong.description;
          }
        })
        .catch(error => {});
    }
  },
  data() {
    return {
      time2: "",

      latlong: { lat: 0, lng: 0 },
      VehicleNo: "",
      description: "",
      shortcuts: [
        {
          text: "Today",
          start: new Date(),
          end: new Date()
        }
      ],
      data: {
        labels: [
          "Sleeping",
          "Designing",
          "Coding",
          "Cycling",
          "test",
          "test2",
          "test3"
        ],
        datasets: [
          {
            label: "Number of users",
            data: [140, 145, 150, 155, 160, 165, 170],
            backgroundColor: "#607d8d47",
            borderColor: "#2C3E50",
            borderWidth: 4
            //   pointStyle:'line',
          }
        ]
      },
      options: {
        segmentShowStroke: false
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// map.vue?27dae21a